angular.module("budget_groups")

    .controller("BudgetGroupsEditCtrl", ['LoginService', '$scope', '$rootScope', '$controller', '$state', '$stateParams', 'Restangular', '$uibModal', 'modalService', '$compile', 'gridService', '$filter', '$translate', function (LoginService, $scope, $rootScope, $controller, $state, $stateParams, Restangular, $uibModal, modalService, $compile, gridService, $filter, $translate) {

        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("BUDGET_GROUPS_WRITE");
        $rootScope.title = $filter('translate')('budget_groups.title');

        $scope.budget_group_id = $stateParams.id;

        if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {
       
            $rootScope.breadcrumb = [
                { title: $filter('translate')('budget_groups.title'), url: "budget_groups.list" },
                { title: $filter('translate')('budget_groups.add') },
            ];
            $scope.budget_group = { };
        } else {
            $rootScope.breadcrumb = [
                { title: $filter('translate')('budget_groups.title'), url: "budget_groups.list" },
                { title: $filter('translate')('budget_groups.edit') },
            ];

            Restangular.one('BudgetGroups', $stateParams.id).get().then(function (results) {                
                $scope.budget_group = results;
            });
        }                       
       
        
        $scope.save = function (frmBudgetGroups) {                        
                        
            if (!angular.isUndefined($scope.budget_group.id)) {
                $scope.budget_group.put().then(function (result) {
                    if (typeof (result.id) != "undefined") {
                        toastr.success($filter('translate')('budget_groups.modified_success'));
                        $state.go("budget_groups.list");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            } else {
                Restangular.all('BudgetGroups').post($scope.budget_group).then(function (result) {
                    if (typeof (result.id) != "undefined") {
                        toastr.success($filter('translate')('budget_groups.created_success'));
                        $state.go("budget_groups.list");
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            }
        }

        $scope.checkDelete = function () {
            modalService.confirm({
                title: $filter('translate')('budget_groups.delete'),
                message: $filter('translate')('budget_groups.delete_message') +" "+ $scope.budget_group.name + "?",
                onAccept: function () {
                    $scope.budget_group.remove().then(function () {
                        toastr.success($filter('translate')('budget_groups.remove_success'));
                        $state.go("budget_groups.list");
                    });
                }
            });
        };
               


}])

;

